import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper d-flex flex-row align-items-stretch p-0" }
const _hoisted_2 = { class: "sidebar-content border-right border-right-dark-alpha flex-0" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"sidebar-section p-3\"><div class=\"sidebar-section-header\"><span class=\"font-weight-bold\">Suche Anlage</span></div><form class=\"sidebar-section-body\" action=\"#\"><div class=\"form-group-feedback form-group-feedback-right\"><input type=\"search\" class=\"form-control\" placeholder=\"Type here\"><div class=\"form-control-feedback\"><i class=\"icon-search4 font-size-base text-muted\"></i></div></div></form></div>", 1)
const _hoisted_4 = { class: "sidebar-section" }
const _hoisted_5 = { class: "nav nav-tabs nav-tabs-bottom border-bottom-0 nav-justified" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "sidebar-section" }
const _hoisted_8 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mr-3" }
const _hoisted_11 = { class: "btn bg-transparent border-success text-success rounded-pill border-2 btn-icon" }
const _hoisted_12 = { class: "media-body" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "nav-item"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["nav-link", {'active':index==_ctx.activeTab, 'disabled':tab.disabled}]),
                "data-toggle": "tab",
                onClick: ($event: any) => (_ctx.activeTab=index)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(tab.icon)
                }, null, 2)
              ], 10, _hoisted_6)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (system, systemIndex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: systemIndex,
              class: ""
            }, [
              _createElementVNode("a", {
                class: "media",
                onClick: ($event: any) => (_ctx.showSystem(system.anlage_id))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("i", {
                      class: _normalizeClass(system.icon)
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(system.anlage_typ) + " | " + _toDisplayString(system.anlage_nummer) + " ", 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(system.anlage_bemerkung), 1)
                ]),
                _hoisted_14
              ], 8, _hoisted_9)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}